export const readings = `
declare enum ReadingType {
  analog = "analog",
  digital = "digital",
  boolean = "boolean",
  light = "light",
  distance = "distance",
  voltage = "voltage",
  humidity = "humidity",
  temperature = "temperature",
  sound = "sound",
  pitch = "pitch",
  roll = "roll",
  yaw = "yaw",
  inclination = "inclination",
  azimuth = "azimuth",
  radius = "radius",
  heading = "heading",
  flow = "flow",
  gps = "gps",
  pressure = "pressure",
  concentration = "concentration",
  current = "current",
  speed = "speed",
  frequency = "frequency",
  percentage = "percentage",
  altitude = "altitude",
  weight = "weight",
  acidity = "acidity",
  power = "power",
  reactivePower = "reactive-power",
  energy = "energy",
  reactiveEnergy = "reactive-energy",
  loraRssi = "lora-rssi",
  loraSnr = "lora-snr",
  time = "time",
  acceleration = "acceleration",
  precipitation = "precipitation",
  rain = "rain",
  uv = "uv",
  radiation = "radiation",
  evapotranspiration = "evapotranspiration",
  tag = "tag",
  tagList = "tagList",
  volume = "volume",
  depth = "depth"
}

declare interface ParserReading {
  channelId: number;
  type: ReadingType;
  value: any;
  label?: string;
  unit?: string;
  tsDelta?: number;
}

declare interface LoraMessage {
  ts:number,
  payloadHex:string,
  loraPort:number,
  uplinkCnt:number,
  quality?: {
    rssi: number,
    snr: number,
    spFact: number
  }
  customMeta: object,
  late: boolean
}
`;